// Okno „Wyświetlanie” z menu konta (funkcja starej APP, wygląd z klocków pakietu): motyw, rozmiar wyświetlania
// i rozmiar czcionki - jak w ustawieniach Androida (uklad/motyw.ts), „Nie wygaszaj ekranu”, przewijanie nagłówka
// pulpitu oraz język konta. Zmiana działa od razu.
import { t } from "../i18n/t";
import { WyborJezyka } from "../ekrany/ustawienia/Jezyk";
import { Segmenty } from "./Filtry";
import { IkonaMinus, IkonaPlus } from "./ikony";
import { Okno } from "./Okno";
import { Przelacznik } from "./Pola";
import { Przycisk, PrzyciskIkona } from "./Przyciski";
import {
  SKALE_CZCIONKI, SKALE_EKRANU, blokadaEkranuJest, dotyk, krok, ustawCzcionke, ustawEkran, ustawMotyw, ustawNaglowekPrzewija,
  ustawNieWygaszaj, useWyswietlanie, type Motyw, type Wyswietlanie,
} from "./motyw";

const procent = (v: number) => Math.round(v * 100) + "%";

function Skala({ tytul, lista, wartosc, ustaw, mniej, wiecej }: {
  tytul: string; lista: readonly number[]; wartosc: number; ustaw: (v: number) => void; mniej: string; wiecej: string;
}) {
  const nizej = krok(lista, wartosc, -1);
  const wyzej = krok(lista, wartosc, 1);
  return (
    <div className="iot-wiersz-miedzy iot-wyswietlanie__skala" role="group" aria-label={tytul}>
      <span className="iot-pole__etykieta">{tytul}</span>
      <span className="iot-wiersz">
        <PrzyciskIkona ikona={IkonaMinus} obrys etykieta={mniej} disabled={nizej == null} onClick={() => nizej != null && ustaw(nizej)} />
        <output className="iot-num iot-wyswietlanie__wartosc" aria-live="polite">{procent(wartosc)}</output>
        <PrzyciskIkona ikona={IkonaPlus} obrys etykieta={wiecej} disabled={wyzej == null} onClick={() => wyzej != null && ustaw(wyzej)} />
      </span>
    </div>
  );
}

function opisBlokady(w: Wyswietlanie): string {
  if (!blokadaEkranuJest()) return t("Ta przeglądarka nie obsługuje tej opcji.");
  if (!w.nieWygaszaj) return t("Ekran gaśnie normalnie, jak w ustawieniach telefonu.");
  if (w.blokada === "trzyma") return t("Ekran nie zgaśnie, dopóki aplikacja jest na wierzchu.");
  if (w.blokada === "odmowa") return t("Telefon nie pozwolił - dotknij ekranu albo wyłącz tryb oszczędzania energii.");
  return t("Zadziała, gdy aplikacja wróci na wierzch.");
}

export function OknoWyswietlania({ otwarte, onZmianaOtwarcia }: { otwarte: boolean; onZmianaOtwarcia: (o: boolean) => void }) {
  const w = useWyswietlanie();
  const domyslne = (w.ekran === 1 || !dotyk()) && w.czcionka === 1;
  return (
    <Okno otwarte={otwarte} onZmianaOtwarcia={onZmianaOtwarcia} tytul={t("Wyświetlanie")}      akcje={<Przycisk wariant="glowny" onClick={() => onZmianaOtwarcia(false)}>{t("Gotowe")}</Przycisk>}>
      <div className="iot-formularz">
        <div className="iot-pole">
          <span className="iot-pole__etykieta">{t("Motyw")}</span>
          <Segmenty etykieta={t("Motyw")} wartosc={w.motyw} onZmien={(m: Motyw) => ustawMotyw(m)} pelne
            opcje={[{ wartosc: "light", etykieta: t("Jasny") }, { wartosc: "dark", etykieta: t("Ciemny") }]} />
        </div>
        {dotyk() ? (
          <Skala tytul={t("Rozmiar wyświetlania")} lista={SKALE_EKRANU} wartosc={w.ekran} ustaw={ustawEkran}
            mniej={t("Mniejsze wyświetlanie")} wiecej={t("Większe wyświetlanie")} />
        ) : (
          <p className="iot-cichy iot-maly">
            {t("Na komputerze całą stronę powiększysz klawiszami Ctrl + i Ctrl − (na Macu ⌘ + i ⌘ −).")}
          </p>
        )}
        <Skala tytul={t("Rozmiar czcionki")} lista={SKALE_CZCIONKI} wartosc={w.czcionka} ustaw={ustawCzcionke}
          mniej={t("Mniejsza czcionka")} wiecej={t("Większa czcionka")} />
        <Przycisk wariant="obrys" disabled={domyslne} onClick={() => { ustawEkran(1); ustawCzcionke(1); }}>
          {t("Przywróć domyślne (100%)")}
        </Przycisk>
        <Przelacznik etykieta={t("Nie wygaszaj ekranu")} pomoc={opisBlokady(w)} wlaczony={w.nieWygaszaj && blokadaEkranuJest()}
          wylaczony={!blokadaEkranuJest()} onZmien={ustawNieWygaszaj} odwrotny />
        <Przelacznik etykieta={t("Nagłówek pulpitu przewija się z ekranem")} wlaczony={!w.naglowekStaly} onZmien={ustawNaglowekPrzewija} odwrotny
          pomoc={w.naglowekStaly ? t("Nagłówek z nazwą pulpitu zostaje u góry przy przewijaniu.") : t("Nagłówek odjeżdża w górę razem z kartami.")} />
        {/* bez tłumaczenia - do znalezienia w każdym języku */}
        <WyborJezyka etykieta="Język / Language" />
      </div>
    </Okno>
  );
}
